import Box from "@mui/material/Box"
import MuiCard from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import Typography from "@mui/material/Typography"
import AppLink from "components/navigation/AppLink"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles<{
  size: number
  height: number
  mediaHeight: number
  subFontSize: number
  tagColour: string
}>()(
  (_theme, p) => ({
    root: {
      maxWidth: `${p.size}px`,
      minWidth: `${p.size}px`,
      minHeight: `${p.height}px`,
      margin: "20px 18px 20px 2px",
      "&.MuiPaper-rounded": {
        borderRadius: "10px",
      },
    },
    coverBox: {
      position: "relative",
      width: "100%",
    },
    coverTags: {
      position: "absolute",
      top: "0px",
      left: "0px",
      padding: "10px",
      height: "39px",
      background: `${p.tagColour}`,
      borderRadius: "10px 0px",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    tag: {
      fontFamily: "Lato",
      fontStyle: "italic",
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#FFFFFF",
    },
    media: {
      height: `${p.mediaHeight}px`,
      backgroundSize: "cover",
    },
    cardContentContainer: {
      minHeight: "130px",
      padding: "15px",
    },
    heading: {
      fontFamily: "Lato",
      fontSize: `${p.subFontSize}px`,
      lineHeight: `${p.subFontSize + 3}px`,
      fontWeight: 400,
      color: "#556064",
      letterSpacing: 0,
      marginBottom: "15px",
    },
    subtitle: {
      fontFamily: "Lato",
      fontSize: `${p.subFontSize}px`,
      lineHeight: `${p.subFontSize + 3}px`,
      fontWeight: 400,
      color: "#262B2D",
      letterSpacing: 0,
      marginBottom: "5px",
    },
    title: {
      fontFamily: "Raleway",
      fontSize: "24px",
      lineHeight: "29px",
      fontWeight: 500,
      color: "#556064",
      letterSpacing: 0,
    },
  })
)

interface ICard {
  imageUrl: string
  title: string
  subTitle: string
  headingText: string
  redirect: string
  tag: "live" | "coming soon"
}

const Card = (props: ICard) => {
  const { imageUrl, title, subTitle, headingText, redirect, tag } = props

  const size = 300,
    height = 360,
    mediaHeight = 180,
    subFontSize = 16

  const { classes } = useStyles({
    size,
    height,
    mediaHeight,
    subFontSize,
    tagColour: tag === "coming soon" ? "#0470C8" : "#000000",
  })

  return (
    <MuiCard className={classes.root} elevation={3}>
      <Box className={classes.coverBox}>
        <CardMedia image={imageUrl} className={classes.media} />
        <Box className={classes.coverTags}>
          <Typography className={classes.tag}>
            {tag === "live" ? "Live Now" : "Starting soon"}
          </Typography>
        </Box>
      </Box>
      <CardContent className={classes.cardContentContainer}>
        <Typography className={classes.heading}>{headingText}</Typography>
        <Typography className={classes.subtitle}>{subTitle}</Typography>
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <AppLink size="small" href={redirect} color="primary">
          View Details
        </AppLink>
      </CardActions>
    </MuiCard>
  )
}

export default Card
